import {
    Container,
    Paper,
} from "@mui/material";
import {useState} from "react";
import {useParams} from "react-router-dom";
import Register from "../components/auth/Register";
import Login from "../components/auth/Login";
import EmailVerificationModal from "../components/auth/EmailVerificationModal";

const AuthPage = ({status = 'initial'}) => {
    const [registrationMode, setRegistrationMode] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(status);

    const {token} = useParams();

    const changeModeBtnClickHandler = (status = 'initial') => {
        setRegistrationMode(prevState => !prevState);
        setCurrentStatus(status);
    }

    const onEmailVerificationClose = (status) => {
        setRegistrationMode(false);
        setCurrentStatus(status);
    }

    let element = null;
    if (currentStatus === 'email_verification') {
        element = <EmailVerificationModal token={token} onClose={onEmailVerificationClose} />;
    } else {
        if (registrationMode) {
            element = <Register
                onModeChange={changeModeBtnClickHandler}
                status={currentStatus}
            />;
        } else {
            element =  <Login
                onModeChange={changeModeBtnClickHandler}
                status={currentStatus}
            />;
        }
    }

    return <>
        <Container maxWidth='false' sx={{padding: 0, background: '#21D4FD', backgroundImage: 'linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)', height: '100dvh', width: '100vw', overflow: 'hidden'}}>
            <Paper sx={{py: { sm:5 }, px: { sm:4 }, position: { sm:'absolute'}, left: { sm:'50%' }, top: { sm:'50%' }, transform: { sm:'translate(-50%, -50%)' }}}>
                {element}
            </Paper>
        </Container>
    </>
}

export default AuthPage;